module.exports = __webpack_public_path__ + "img/18.f8d5c745.jpg";